import React from "react";

import { message } from "antd";

import { generateRandomId } from "utils";

import { Icon, LazyLoadImage } from "components";

type MessageProps = {
  content: string;
  icon?: "gremlin" | "error" | "tick" | "";
  onClose?: () => void;
  dataTestId?: string;
};

export const Message = ({ content, icon = "", onClose = () => {}, dataTestId }: MessageProps) => {
  const getIcon = () => {
    if (icon === "gremlin") {
      return <LazyLoadImage alt="gremlin" src="/images/misc/gremlin.gif" />;
    }
    if (icon === "error") {
      return <Icon iconName="tabler/alert-circle" className="inline icon margin-right-75" size="s" fill="#DB3804" color="#FFF" />;
    }
    if (icon === "tick") {
      return <Icon iconName="tabler/circle-check" className="inline icon margin-right-75" size="s" fill="#3B9361" color="#FFF" />;
    }

    return <></>;
  };

  // this prevents duplicates of the same message
  const getUniqueKey = () => {
    if (content) {
      return content
        .replace(/[^\w\s]/gi, "")
        .replace(/\s+/g, "-")
        .toLowerCase();
    }
    return generateRandomId();
  };

  message.info({
    key: getUniqueKey(),
    duration: 4,
    content: <div data-testid={dataTestId ?? `${icon}-message-content`}>{content}</div>,
    icon: getIcon(),
    onClose: onClose,
    onClick: () => message.destroy(getUniqueKey()),
  });

  return message;
};

export { message } from "antd";

export default Message;
